import { FGButton, FGIcons } from '@fg/design-system';
import { METHODOLOGIES_PDF_URL } from 'components/Homepage/Methodologies';
import { getCurrentActiveView } from 'utils/generalUtils';
import { getCategoryForPiwik } from 'PageTitles';
import { trackCustomEvent } from 'utils/piwikUtils';

const MethodologiesButton = () => {
    const onClick = () => {
        const activeView = getCurrentActiveView();
        const category = getCategoryForPiwik(activeView);
        trackCustomEvent(`Geo Risk Signals ${category}`, 'Select Info', `${category} Methodology Info Click`);
        window.open(METHODOLOGIES_PDF_URL, '_blank');
    }
    return (
        <FGButton
            className="methodologies-button"
            variant="secondary"
            icon={<FGIcons icon="Info" />}
            onClick={onClick}
            aria-label="Methodologies"
            title="Methodologies"
        />
    );
};

export default MethodologiesButton;